/**
 * Button-styled dropdown that reveals a list of clickable items on hover.
 *
 * @component
 * @param {Object} props
 * @param {String} props.label - Label displayed on the trigger button.
 * @param {Array} props.items - List of items; each needs a `label` and a `command` click handler.
 * @param {String} [props.icon] - Optional icon class rendered before the label.
 * @param {Boolean} [props.disabled] - Whether the trigger is rendered in a disabled state.
 * @returns {React.JSX.Element}
 */
export default function DropdownHover({ label, items, icon, disabled }) {
  return (
    <div className="dropdown-hover">
      <div
        className={`p-button p-component p-button-text p-button-rounded ${disabled ? 'p-disabled' : ''}`}
      >
        {icon && <span className={`p-button-icon p-c p-button-icon-left ${icon}`} />}
        <span className="p-button-label p-c">{label}</span>
        <i className="ml-2 fas fa-angle-down" />
      </div>
      <div className="dropdown-menu">
        <div className="dropdown-content">
          {items.map((item, key) => {
            return (
              <div
                key={key}
                onClick={item.command}
                className="dropdown-item"
              >
                {item.label}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
